import { ArrowRight, Phone, Mail, MessageCircle, Sparkles } from 'lucide-react';
import { Reveal } from './motion/Reveal';
import { StaggerGroup, StaggerItem } from './motion/Stagger';

export const CTASection = () => {
  return (
    <section
      id="contato"
      data-testid="cta-section"
      className="py-20 bg-slate-50"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal delay={0.1} className="relative overflow-hidden bg-blue-600 rounded-3xl">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full translate-y-1/2 -translate-x-1/2" />
          </div>

          <div className="relative p-8 md:p-12 lg:p-16">
            <Reveal delay={0.2} className="text-center max-w-2xl mx-auto mb-10">
              <div className="inline-flex items-center gap-2 bg-white/20 text-white text-sm font-semibold px-4 py-2 rounded-full mb-6">
                <Sparkles className="w-4 h-4" />
                <span>Vamos resolver isso juntos</span>
              </div>
              <h2
                data-testid="cta-title"
                className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4"
              >
                Pronto pra buscar o que é seu por direito?
              </h2>
              <p className="text-blue-100 text-lg leading-relaxed">
                Fale com a gente agora! Nossa análise é 100% gratuita e sem compromisso.
                Você só paga se ganhar.
              </p>
            </Reveal>

            {/* Contact Options */}
            <StaggerGroup staggerDelay={0.1} startDelay={0.3} className="grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
              <StaggerItem
                as="a"
                href="https://wa.me/5511999999999"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-link"
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.97 }}
                className="flex items-center gap-4 bg-white rounded-2xl p-5 transition-shadow duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_-15px_rgba(37,99,235,0.25)] group"
              >
                <div className="w-12 h-12 bg-green-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MessageCircle className="w-6 h-6 text-white" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-slate-900">WhatsApp</p>
                  <p className="text-slate-500 text-sm">Resposta rápida</p>
                </div>
              </StaggerItem>

              <StaggerItem
                as="a"
                href="tel:+5511999999999"
                data-testid="phone-link"
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.97 }}
                className="flex items-center gap-4 bg-white rounded-2xl p-5 transition-shadow duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_-15px_rgba(37,99,235,0.25)] group"
              >
                <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-slate-900">Telefone</p>
                  <p className="text-slate-500 text-sm">(11) 99999-9999</p>
                </div>
              </StaggerItem>

              <StaggerItem
                as="a"
                href="mailto:contato@quaissaomeusdireitos.com"
                data-testid="email-link"
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.97 }}
                className="flex items-center gap-4 bg-white rounded-2xl p-5 transition-shadow duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_-15px_rgba(37,99,235,0.25)] group"
              >
                <div className="w-12 h-12 bg-slate-700 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-slate-900">E-mail</p>
                  <p className="text-slate-500 text-sm">Envie sua dúvida</p>
                </div>
              </StaggerItem>
            </StaggerGroup>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
